import {
	Download,
	Edit,
	Receipt,
	CheckCircle,
	CheckCircleOutline,
	PictureAsPdf,
	TableChart,
	Comment,
	Send,
	CancelScheduleSend,
	Delete,
	Block,
	Cancel,
	ErrorOutline,
	AccountCircle,
	AdminPanelSettings,
	HowToReg,
	LockReset,
	Mail,
	PersonRemove,
	SupervisedUserCircle,
	EventBusy,
	EventRepeat,
	Stop,
	Notifications,
	CloudDownload,
	CreditCard,
	LocalShipping,
	Place,
} from '@mui/icons-material';
import { Card } from '@mui/material';

export enum EIconButtons {
	CARD = 'Card',
	DOWNLOAD = 'Download',
	CLOUD_DOWNLOAD = 'CloudDownload',
	EDIT = 'Edit',
	DELETE = 'Delete',
	RECEIPT = 'Receipt',
	PICTURE_AS_PDF = 'PictureAsPdf',
	TABLE_CHART = 'TableChart',
	COMMENT = 'Comment',
	SEND = 'Send',
	CANCEL_SCHEDULE_SEND = 'CancelScheduleSend',
	CHECK_CIRCLE = 'CheckCircle',
	BLOCK = 'Block',
	CANCEL = 'Cancel',
	ERROR_OUTLINE = 'ErrorOutline',
	ACCOUNT_CIRCLE = 'AccountCircle',
	ADMIN_PANEL_SETTINGS = 'AdminPanelSettings',
	HOW_TO_REG = 'HowToReg',
	LOCK_RESET = 'LockReset',
	MAIL = 'Mail',
	PERSON_REMOVE = 'PersonRemove',
	SUPERVISED_USER_CIRCLE = 'SupervisedUserCircle',
	EVENT_BUSY = 'EventBusy',
	EVENT_REPEAT = 'EventRepeat',
	STOP = 'Stop',
	NOTIFICATION = 'Notification',
	LOCAL_SHIPPING = 'LocalShipping',
	PLACE = 'Place',
}

export const ICON_BUTTONS = {
	[EIconButtons.CARD]: CreditCard,
	[EIconButtons.DOWNLOAD]: Download,
	[EIconButtons.CLOUD_DOWNLOAD]: CloudDownload,
	[EIconButtons.EDIT]: Edit,
	[EIconButtons.DELETE]: Delete,
	[EIconButtons.RECEIPT]: Receipt,
	[EIconButtons.PICTURE_AS_PDF]: PictureAsPdf,
	[EIconButtons.TABLE_CHART]: TableChart,
	[EIconButtons.COMMENT]: Comment,
	[EIconButtons.SEND]: Send,
	[EIconButtons.CANCEL_SCHEDULE_SEND]: CancelScheduleSend,
	[EIconButtons.CHECK_CIRCLE]: CheckCircle,
	[EIconButtons.BLOCK]: Block,
	[EIconButtons.CANCEL]: Cancel,
	[EIconButtons.ERROR_OUTLINE]: ErrorOutline,
	[EIconButtons.ACCOUNT_CIRCLE]: AccountCircle,
	[EIconButtons.ADMIN_PANEL_SETTINGS]: AdminPanelSettings,
	[EIconButtons.HOW_TO_REG]: HowToReg,
	[EIconButtons.LOCK_RESET]: LockReset,
	[EIconButtons.MAIL]: Mail,
	[EIconButtons.PERSON_REMOVE]: PersonRemove,
	[EIconButtons.SUPERVISED_USER_CIRCLE]: SupervisedUserCircle,
	[EIconButtons.EVENT_BUSY]: EventBusy,
	[EIconButtons.EVENT_REPEAT]: EventRepeat,
	[EIconButtons.STOP]: Stop,
	[EIconButtons.NOTIFICATION]: Notifications,
	[EIconButtons.LOCAL_SHIPPING]: LocalShipping,
	[EIconButtons.PLACE]: Place,
};
